import {tokenDefinition} from "../../token/tokenDefinition.mjs";
import {TokenType} from "../../token/tokenType.mjs";
import {TokenName} from "./tokenName.mjs";
import {emphasis} from "./emphasis.mjs";
import {hiddenInput} from "./hiddenInput.mjs";
import {colorBlue, colorGreen, colorRed} from "./color.mjs"
import {audio} from "./audio.mjs"
import {closeSpecialElement, openSpecialElement} from "./specialElement.mjs"
import {lineFeed} from "./lineFeed.mjs";
import {title1, title2, title3} from "./title.mjs";
import {pipe} from "./pipe.mjs";
import {writingPractice} from "./writingPractice.mjs";
import {table} from "./table.mjs";
import {tableHeader} from "./tableRow.mjs";

const space = tokenDefinition({
    name: TokenName.SPACE,
    type: TokenType.DELIMITER,
    tokenMatcher: /^ /,
    contentMatcher: /^ /
});

const tokenDefinitions = [
    writingPractice,
    table,
    tableHeader,
    openSpecialElement, closeSpecialElement,
    colorRed, colorBlue, colorGreen,
    audio,
    pipe,
    lineFeed,
    title1, title2, title3,
    emphasis,
    hiddenInput,
    space,
];

export {space, tokenDefinitions}